let totalPackPrice = 0

function changeTotalPrice(price){
    if(price == 0){
        document.querySelector('.total-pack-desktop').innerHTML = ""
        document.querySelector('.total-pack').innerHTML = ""
    }else{
        document.querySelector('.total-pack-desktop').innerHTML = " - " + "€" + price
        document.querySelector('.total-pack').innerHTML = " - " + "€" + price
    }

    //Calculate total amount of items added
    const itemsAdded = document.querySelectorAll('.js-add-product-to-pack.added')
    document.querySelector('.js-total-added').innerHTML = itemsAdded.length
}


customElements.define("pack-product", class PackProduct extends HTMLElement{
    constructor(){
        super()


        this.addToPackBtns = this.querySelectorAll('.js-add-product-to-pack')
        this.quantityMinusBtns = this.querySelectorAll('.js-minus-quantity')
        this.quantityPlusBtns = this.querySelectorAll('.js-plus-quantity')
        this.toggleMobileResumeBtn = this.querySelector('.js-toggle-resume')
        this.addToCartBtns = this.querySelectorAll('.js-add-pack-to-cart')
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.emptyMessages = this.querySelectorAll('.main-product-pack__items-empty')
        this.packTotal = this.querySelector('.total-pack-desktop')
        this.packTotalMobile = this.querySelector('.total-pack')
        this.packTotalQuantity = this.querySelector('.js-total-added')

        this.totalPackPrice = 0


        this.addToPackBtns.forEach(btn=>btn.addEventListener("click", this.addProductToPack.bind(this)))
        // Hacer clickable todo el wrapper del producto
        this.querySelectorAll('[data-clickable-wrapper]').forEach(wrapper => {
        wrapper.addEventListener('click', (e) => {
            // Evitar que el clic venga del propio botón (ya tiene su listener)
            if (e.target.closest('.js-add-product-to-pack')) return;

            const btn = wrapper.querySelector('.js-add-product-to-pack');
            // Si el botón está deshabilitado (agotado), no hacer nada
            if (!btn || btn.disabled) return;

            btn.click(); // dispara el mismo evento que el botón original
        });
        });

        this.quantityMinusBtns.forEach(btn=>btn.addEventListener("click", this.modifyQuantiyForItem.bind(btn, "minus")))
        this.quantityPlusBtns.forEach(btn=>btn.addEventListener("click", this.modifyQuantiyForItem.bind(btn, "plus")))
        this.toggleMobileResumeBtn.addEventListener("click", this.toggleMobileResume.bind(this))
        this.addToCartBtns.forEach(btn=>btn.addEventListener("click", this.addToCart.bind(this)))
    }

    toggleMobileResume(){
        this.toggleMobileResumeBtn.closest(".main-product-pack__resume-mobile").classList.toggle('active')
    }

    addProductToPack(e){
    // El listener está en el botón; e.currentTarget es el botón
    const btn = e.currentTarget || e.target.closest('.js-add-product-to-pack');
    if (!btn) return;

    // No hacer nada si ya está añadido o deshabilitado
    if (btn.disabled || btn.classList.contains('added')) return;

    // Precio y variantId siempre desde el botón
    const price = parseFloat(btn.dataset.price);
    const variantId = btn.dataset.packProductId;

    // Activa items espejo
    const relatedListItems = this.querySelectorAll(`[data-product-id="${variantId}"]`);
    relatedListItems.forEach(relatedListItem => {
        relatedListItem.classList.add("active");
    });

    // UI y total
    this.emptyMessages.forEach(message => message.classList.add("hidden"));
    btn.classList.add("added");

    // Deshabilita el botón para evitar re-clics
    btn.disabled = true;

    // (Opcional) marca el wrapper como inactivo visualmente
    const infoWrapper = btn.closest('.pack-item')?.querySelector('[data-clickable-wrapper]');
    if (infoWrapper) infoWrapper.classList.add('is-disabled');

    // Total solo se suma una vez al añadir la tarjeta
    totalPackPrice += price;
    changeTotalPrice(totalPackPrice);
    }



   modifyQuantiyForItem(type, e) {
        const item = e.target;
        const listItem = item.closest('.pack-item-list');
        const itemPrice = parseFloat(listItem.dataset.price);
        const addWrapper = listItem.querySelector('.pack-item-list__add-wrapper');
        const quantityInput = addWrapper.querySelector('input.pack-item-list__quantity-input');
        const quantityLabel = addWrapper.querySelector('p.pack-item-list__quantity-input');

        let currentQuantity = parseInt(quantityInput.value, 10) || 0;
        const maxQty = parseInt(listItem.dataset.maxQty || '999', 10);

        // Botones + y -
        const plusBtn = listItem.querySelector('.js-plus-quantity');
        const minusBtn = listItem.querySelector('.js-minus-quantity');

        switch (type) {
            case "minus": {
                if (currentQuantity <= 0) return;
                currentQuantity--;
                totalPackPrice -= itemPrice;

                if (currentQuantity > 0) {
                    quantityInput.value = currentQuantity;
                    quantityLabel.innerHTML = currentQuantity;
                } else {
                    listItem.classList.remove("active");

                    const relatedAtc = document.querySelector(
                    `[data-pack-product-id="${listItem.dataset.productId}"]`
                    );
                    if (relatedAtc) {
                    relatedAtc.classList.remove("added");
                    relatedAtc.disabled = false; // ✅ volver a habilitar el botón "Añadir"
                    }

                    const activeItems = window.innerWidth < 768
                    ? document.querySelectorAll('.main-product-pack__items-list-wrapper--mobile .pack-item-list.active')
                    : document.querySelectorAll('.main-product-pack__items-list-wrapper--desktop .pack-item-list.active');

                    if (!activeItems.length) {
                    document.querySelectorAll('.main-product-pack__items-empty')
                        .forEach(message => message.classList.remove("hidden"));
                    }
                }

                // re-habilita "+" si procede (si lo desactivas al llegar al máximo)
                const plusBtn = listItem.querySelector('.js-plus-quantity');
                const maxQty = parseInt(listItem.dataset.maxQty || '999', 10);
                if (plusBtn && plusBtn.disabled && (currentQuantity < maxQty)) {
                    plusBtn.disabled = false;
                }

                break;
                }


            case "plus": {
            if (currentQuantity >= maxQty) return; // no superar
            currentQuantity++;
            totalPackPrice += itemPrice;

            quantityInput.value = currentQuantity;
            quantityLabel.innerHTML = currentQuantity;
            listItem.classList.add("active");

            // ⛔ Si llegamos al máximo, deshabilitar el +
            if (currentQuantity >= maxQty) {
                plusBtn.disabled = true;
            }

            break;
            }
        }

        changeTotalPrice(totalPackPrice);
        }



    addToCart() {
    const itemsToAdd = [];
    const purchaseOption = this.querySelector('input[name="PackPurchaseOption"]:checked').value;
    const activeItems = window.innerWidth < 768
        ? this.querySelectorAll('.main-product-pack__items-list-wrapper--mobile .pack-item-list.active')
        : this.querySelectorAll('.main-product-pack__items-list-wrapper--desktop .pack-item-list.active');

    activeItems.forEach(item => {
        const itemData = JSON.parse(item.dataset.packProductData);
        const itemQuantity = parseInt(item.querySelector('input.pack-item-list__quantity-input').value);

        if (purchaseOption === "subscription") {
            itemsToAdd.push({
                id: itemData.variantId,
                selling_plan: itemData.sellingPlan,
                quantity: itemQuantity
            });
        } else {
            itemsToAdd.push({
                id: itemData.variantId,
                quantity: itemQuantity
            });
        }
    });

    // Enviar productos al carrito
    fetch(`${window.Shopify.routes.root}cart/add.js?sections=cart-notification-product,cart-notification-button,cart-count-bubble`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: itemsToAdd })
    })
        .then(response => response.json())
        .then(parsedState => {

    // Buscar el contenedor del icono del carrito
    const cartIconBubble = document.getElementById('cart-icon-bubble');

    if (cartIconBubble) {
        // Verificar si ya existe el contador del carrito
        let cartBubble = cartIconBubble.querySelector('.cart-count-bubble');
        if (!cartBubble) {
            // Crear el contenedor del contador si no existe
            cartBubble = document.createElement('div');
            cartBubble.className = 'cart-count-bubble'; // Asignar la clase necesaria

            // Crear el span para el número de productos
            const span = document.createElement('span');
            cartBubble.appendChild(span);

            // Añadir el contador al contenedor del icono del carrito
            cartIconBubble.appendChild(cartBubble);
        }

        // Actualizar el número de productos en el carrito
        const cartCountSpan = cartBubble.querySelector('span');
        if (cartCountSpan) {
            // Leer el contenido actual del contador o usar 0 como predeterminado
            let currentCount = parseInt(cartCountSpan.textContent) || 0;

            // Calcular la cantidad de productos añadidos
            const addedCount = parsedState.items.reduce((sum, item) => sum + item.quantity, 0);

            // Actualizar el contador con el nuevo valor
            cartCountSpan.textContent = currentCount + addedCount;
        }
    } else {
        console.warn('Contenedor del icono del carrito (cart-icon-bubble) no encontrado en el DOM.');
    }

// Mostrar la notificación personalizada
    const notificationWrapper = document.querySelector('.cart-notification-wrapper');

    if (!notificationWrapper) {
        console.warn('El contenedor de notificaciones no se encuentra en el DOM.');
        return;
    }

    const customNotification = document.createElement('div');
    customNotification.classList.add('cart-notification', 'focus-inset', 'active' , 'color-background-1' , 'focus-inset');
    customNotification.setAttribute('role', 'dialog');
    customNotification.setAttribute('aria-modal', 'true');
    customNotification.innerHTML = `
        <div class="cart-notification__header">
            <h2 class="cart-notification__heading caption-large" style="font-size: 2.2rem;">
                <svg class="icon icon-checkmark" aria-hidden="true" focusable="false">
                    <use href="#icon-checkmark"></use>
                </svg>
                ¡Pack añadido al carrito!
            </h2>
            <button type="button" class="cart-notification__close modal__close-button link link--text focus-inset" aria-label="Cerrar notificación">
                <svg class="icon icon-close" aria-hidden="true" focusable="false">
                    <use href="#icon-close"></use>
                </svg>
            </button>
        </div>
        <div class="cart-notification__links">
            <button class="button button--primary button--full-width" onclick="window.location.href='/cart'">Ver carrito</button>
            <button class="button button--secondary button--full-width" onclick="this.closest('.cart-notification').remove()">Seguir comprando</button>
        </div>
    `;

    notificationWrapper.innerHTML = '';
    notificationWrapper.appendChild(customNotification);
    notificationWrapper.style.display = 'block';

    customNotification.querySelector('.cart-notification__close').addEventListener('click', () => {
        customNotification.remove();
    });





    // Vaciar el carrito temporal
    const activeItems = document.querySelectorAll('.pack-item-list.active');
    activeItems.forEach(item => {
        const quantityInput = item.querySelector('input.pack-item-list__quantity-input');
        if (quantityInput) {
            quantityInput.value = 0; // Reiniciar cantidad
        }
        item.classList.remove('active'); // Eliminar estado activo
    });
          // Reiniciar el precio total del pack y actualizar la visualización
    totalPackPrice = 0;
    changeTotalPrice(totalPackPrice);
    // Rehabilitar los botones de selección
    const disabledButtons = document.querySelectorAll('.js-add-product-to-pack.added');
    disabledButtons.forEach(button => {
        button.classList.remove('added'); // Quitar la clase que indica que está añadido
        button.disabled = false; // Habilitar el botón
    });
})

        .catch(error => {
            console.error('Error al añadir productos al carrito:', error);
        });
}

})